import { getInitializedBrazeClient, initBrazeClient } from "./braze-client";
import { initBrazeUser, trackEvent, logCardDismissal } from "./utils";
import {
  useContentCards,
  useDismissContentCard,
  useLogCardImpressions,
  useWebInAppMessages,
  useTrackContentCardViewed,
} from "./hooks";

export default {
  initBrazeClient,
  getInitializedBrazeClient,
  initBrazeUser,
  trackEvent,
  useWebInAppMessages,
  useContentCards,
  useDismissContentCard,
  useLogCardImpressions,
  logCardDismissal,
  useTrackContentCardViewed,
};
